import { Link } from "react-router-dom";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import ClaimListing from "../modals/claimListing";
import "./productDetails.css";
import { useState } from 'react'
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { getProductDetails, updateProductDetail } from "../../redux/actions";
import Cookies from "js-cookie";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { offer, addbidusers } from "../../backend/escrow"
import axios from 'axios'
import SyncLoader from "react-spinners/SyncLoader";
import { css } from "@emotion/react";
import { getCategory, getSubcategory } from "../../redux/actions";
import Backdrop from '@mui/material/Backdrop';
import moment from 'moment'
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import './newcomponent.css'
const ProductDetails = (props) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const queryParams = new URLSearchParams(location.search);
    const productId = queryParams.get("productId");
    const [color, setColor] = useState("#ffffff");
    const [open, setOpen] = useState(true);
    const productDetails = useSelector((state) => state.productDetails.details);
    const [category, setcategory] = useState({});
    const [subcategory, setsubcategory] = useState({});
    const [openModal, toggleopenModal] = useState(false);
    let loggedInUser = useSelector((state) => state.userDetails.isLoggedIn);
    let user = useSelector((state) => state.userDetails.user);
    const [mainImage, setMainImage] = useState();
    const [slideImage, setslideImage] = useState([]);
    const [claimedlistflag, setclaimedlistflag] = useState(true);
    const [makeanofferlistflag, setmakeanofferlistflag] = useState(true);
    const history = useHistory();
    const [modal1, setmodal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [disable, setdisable] = useState(false);

    const callback = () => {
        setOpen(false);
    }

    // const [sellerexist, setsellerexist] = useState(false)
    // const [openverifyModal, toggleopenverifyModal] = useState(false);
    // const [seller, setseller] = useState({});
    // alert(JSON.stringify(location))
    // const params = new URLSearchParams(window.location.search);

    const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;

    //Owl Carousel Settings
    const options = {
        loop: true,
        interval: 5000,
        margin: 10,
        responsiveClass: true,
        responsive: {
            0: {
                items: 3,
                nav: true
            },
            600: {
                items: 4,
                nav: false
            },
            1000: {
                items: 5,
                nav: true,
                loop: false
            }
        }
    }

    const categoryDetail = useSelector((state) => {
        return state.categoryDetail.categories
    });

    const subcategoryDetail = useSelector((state) => {
        return state.subCategoryDetail.subCategories
    });




    const toggle1 = () => {
        setmodal(!modal1)
    }
    const toggle = () => {
        if (Cookies.get('token') && loggedInUser) {
            toggleopenModal(!openModal);
        }
        else {
            history.push('/login')
        }
    };

    // useEffect(async()=>{
    //     if(productDetails.is_seller)
    //     {
    //     const response = await axios.request({
    //              method: 'POST',
    //              headers: {
    //                  'Content-Type': 'application/json',
    //                  'Authorization': Cookies.get('token')
    //              },
    //              data:{sellerId:productDetails.sellerId},
    //              url: `${process.env.REACT_APP_SERVER_URL}/v1/users/get-user`
    //          }).then((res)=>{setseller(res.data.data);}).catch((error)=>
    //          {
    //              console.log(error)
    //          })
    //  }
    // },[])
    useEffect(() => {
        window.scrollTo(0, 0);
        dispatch(getCategory());
        dispatch(getSubcategory())

        // if (productDetails) {


        //     const cat = categoryDetail.find(cat => cat._id === productDetails.categoryId);
        //     setcategory(cat)

        //     const subcat = subcategoryDetail.find(cat => cat._id === productDetails.subCategoryId);
        //     setsubcategory(subcat)
        // }

        if (loggedInUser) {
            if (user.role[0] == "admin") {
                setclaimedlistflag(false)
                setmakeanofferlistflag(false)
            }
        }
    }, [])


    useEffect(() => {
        dispatch(getProductDetails(productId, history, callback));
    }, [location.key])

    useEffect(() => {
        dispatch(getProductDetails(productId, history, callback));
    }, [dispatch, productId, location.key])

    useEffect(() => {
        if (productDetails && productDetails.images && productDetails._id === productId) {
            setOpen(false);
            const images_array = []
            productDetails.images.map((img) => {
                images_array.push({
                    original: `${process.env.REACT_APP_SERVER_URL}/images/${img}`,
                    thumbnail: `${process.env.REACT_APP_SERVER_URL}/images/${img}`,
                })
            })
            setslideImage(images_array)
            // console.log(slideImage)
            // alert(JSON.stringify(slideImage))
        }
        if (productDetails) {
            const cat = categoryDetail.find(cat => cat._id === productDetails.categoryId);
            setcategory(cat)

            const subcat = subcategoryDetail.find(cat => cat._id === productDetails.subCategoryId);
            setsubcategory(subcat)
        }
    }, [productDetails])

    useEffect(() => {
        if (!open)
            setMainImage(productDetails.images[0]);



    }, [open])

    const makeAnOffer = async () => {
        setdisable(true);
        setLoading(true);

        await axios.request({
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': Cookies.get('token')
            },
            data: { sellerId: productDetails.sellerId },
            url: `${process.env.REACT_APP_SERVER_URL}/v1/users/get-user`
        }).then(async (res) => {
            const auction_data = await offer({
                _id: productDetails._id,
                minimumOfferPrice: productDetails.minimumOfferPrice,
                description: productDetails.description,
                seller: res.data.data,
                userId: user._id,
                title: productDetails.title,
                productcategory: productDetails.categoryId,
                buyNowPrice: productDetails.buyNowPrice,
            })
            await dispatch(updateProductDetail(auction_data))
            window.open(auction_data.make_offer_page, "_blank", "resizable=yes, scrollbars=yes, titlebar=yes, width=800, height=900, top=10, left=10")
            props.socket.emit("new_notification",
                {
                    name: user.firstname,
                    email: user.email,
                    message: `bid on ${productDetails.title}`
                });
            const url = process.env.REACT_APP_SERVER_URL;
            const endpoint = `${url}/v1/notifications/add-notifications`
            const data = { name: user.firstname, email: user.email, message: `bid on ${productDetails.title}` }
            await axios({ data, headers: { 'Content-Type': 'application/json', 'Authorization': Cookies.get('token') }, method: 'post', timeout: 1000 * 60 * 10, url: endpoint, });

            setdisable(false);
            setLoading(false);

        }).catch((error) => {
            console.log(error)
        })

    }


    return (
        <>
            <div id="wrapper" className="d-flex justify-content-between">
                <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={open}>
                    <SyncLoader color={"#ff7e06"} loading={true} css={override} size={11} />
                </Backdrop>
                <div className="container">
                    {productDetails && !productDetails.is_seller && <div className="row">
                        {claimedlistflag &&
                            <div className="col-12">
                                <div className="col-12 bg-orange py-3  mb-5 claim-banner d-flex justify-content-between align-items-center border-radius4">
                                    <p className="text-white mb-0 font-18 "> This listing is unclaimed. If it belongs to you, click the button to claim</p>
                                    <div>
                                        <button type="button" onClick={toggle} className="claim-listing">Claim Listing</button>
                                        <span>
                                            {/* <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M13.2812 3.71875L3.71875 13.2812" stroke="white" stroke-opacity="0.7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M13.2812 13.2812L3.71875 3.71875" stroke="white" stroke-opacity="0.7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg> */}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>}
                    <div className="row  mt-4 pt-2">
                        <div className="col-lg-7">
                            {/* <div className="main-image">
                                {productDetails && productDetails.images && productDetails.images.length != 0 && <img className="mb-4" src={`${process.env.REACT_APP_SERVER_URL}/images/${mainImage}`} alt="" />}
                                {productDetails && productDetails.images && productDetails.images == 0 && <img className="border border-5 mb-4" src={`${process.env.REACT_APP_URL}/static/images/sample-img.jpg`} alt="" />}


                            </div>

                            <div className="pro-slider">
                                <div className="row blog">
                                    <div className="col-md-12">
                                        <div id="blogCarousel" className="carousel slide" data-ride="carousel">
                                             <div className="owl-carousel owl-theme"> 
                                            {productDetails && productDetails.images && productDetails._id === productId && <OwlCarousel className="slider-items owl-carousel" {...options}>
                                                {(() => {
                                                    return productDetails.images.map((image, index) => {
                                                        return (<div className="item" key={index}>
                                                            <Link to={`${window.location.pathname}?productId=${productId}`} onClick={() => setMainImage(image)}>
                                                                <img src={`${process.env.REACT_APP_SERVER_URL}/images/${image}`} alt="" style={{ maxWidth: "100%" }} />
                                                            </Link>
                                                        </div>);
                                                    })
                                                })()}
                                            </OwlCarousel>}

                                             </div> 
                                        </div>
                                    </div>
                                </div>
                            </div> */}


                            <div className="product--gallery">
                                <ImageGallery
                                    showPlayButton={false}
                                    showNav={false}
                                    showFullscreenButton={false}
                                    items={(productDetails && productDetails.images && productDetails.images.length == 0) ? [{
                                        original: `${process.env.REACT_APP_URL}/static/images/sample-img.jpg`,
                                        thumbnail: `${process.env.REACT_APP_URL}/static/images/sample-img.jpg`,
                                    }, {
                                        original: `${process.env.REACT_APP_URL}/static/images/sample-img.jpg`,
                                        thumbnail: `${process.env.REACT_APP_URL}/static/images/sample-img.jpg`,
                                    }] : slideImage}
                                />
                            </div>
                        </div>
                        <div className="col-lg-5 product-details">
                            <div className="b-crum category-names-list">
                                <div className="row mb-3">
                                    <div className="col-lg-4 detail-label">Category:</div>
                                    <div className="col-lg-8 detail-value">
                                        <ul className="m-0 p-0 d-flex"><li>{category ? category.name : ''}</li><li>{subcategory ? subcategory.name : ''}</li></ul>
                                    </div>
                                </div>
                                {/* <ul className="m-0 p-0 d-flex"><li><strong>Category</strong></li><li>{category ? category.name:''}</li><li>{subcategory ? subcategory.name:''}</li></ul> */}
                            </div>
                            <div className="product-name mb-4">{productDetails ? productDetails.title : ""}</div>
                            <div className="row mb-5 mt-5">
                                <div className="col-lg-4 detail-label">Location</div>
                                <div className="col-lg-8 detail-value">{productDetails ? productDetails.city : ""} {productDetails ? productDetails.country : ""}, {productDetails ? productDetails.postalCode : ""}</div>
                            </div>
                            {/* <div className="row mb-3">   <div className="col-lg-4 detail-label">Species</div><div className="col-lg-8 detail-value">{productDetails ? productDetails.species : ""}</div></div> */}
                            <div className="row mb-5">  <div className="col-lg-4 detail-label">Breed</div><div className="col-lg-8 detail-value">{productDetails ? productDetails.breed : ""}</div></div>
                            {/* <div className="row mb-3"> <div className="col-lg-4 detail-label">Sex</div><div className="col-lg-8 detail-value">{productDetails ? productDetails.sex : ""}</div></div> */}
                            <div className="row mb-5"> <div className="col-lg-4 detail-label">Age</div><div className="col-lg-8 detail-value">{productDetails ? productDetails.age : ""}</div></div>
                            {/* <div className="row mb-3"> <div className="col-lg-4 detail-label">Weight Range </div><div className="col-lg-8 detail-value">{"Missing Field"}</div></div>
                            <div className="row mb-3"><div className="col-lg-4 detail-label">Delivery</div><div className="col-lg-8 detail-value">{"Missing Field"}</div></div> */}

                            <div className="listingTableHeader">
                                {/* <div className="custom-control custom-checkbox pb-5 mt-4 pt-2">
                                    <input type="checkbox" className="custom-control-input" id="customCheck1" />
                                    <label className="custom-control-label" for="customCheck1">Request Free freight Quote</label>
                                </div> */}
                                {/* <label className="category-label d-flex align-items-center">Request Free freight Quote
                                    <input type="checkbox" />
                                    <span className="checkmark"></span>
                                </label> */}
                                <label className="right-label-checkbox">Request Free freight Quote
                                    <input type="checkbox" />
                                    <span className="checkmark"></span>
                                </label>
                            </div>
                            {productDetails && productDetails.is_seller && makeanofferlistflag && <div className="offerButtons d-flex align-items-center justify-content-between flex-wrap">

                                {productDetails.sellerId !== user._id && productDetails.status !== "Sold" && productDetails.buyNowPrice > 0 && <button type="button" onClick={toggle1} className="btn btn-custom text-white d-flex align-items-center justify-content-between"><span className="offer-text-1 font-weight-bold d-inline-block align-top pr-2 mr-2">${productDetails ? parseFloat(productDetails.buyNowPrice).toFixed(2) : ""}</span>   Make An Offer</button>}
                                {productDetails.sellerId !== user._id && productDetails.status === "Sold" && productDetails.buyNowPrice > 0 && <button type="button" className="btn btn-custom text-white d-flex align-items-center justify-content-between" disabled><span className="offer-text font-weight-bold d-inline-block align-top" style={{ border: "none" }}>Sold</span></button>}
                                {productDetails.sellerId !== user._id && productDetails.buyNowPrice === 0 && <button type="button" onClick={() => history.push("contact-us")} className="btn btn-custom text-white d-flex align-items-center justify-content-between"><span className="offer-text font-weight-bold d-inline-block align-top" style={{ border: "none" }}>Contact Us</span></button>}
                            </div>
                            }
                        </div>
                    </div>
                    <div className="row mt-4 pt-2 align-items-center">
                        <div className="col-lg-9">
                            <div className="descriptionInfo">
                                <h5 className="product-name mb-3 text-dark">Description</h5>
                                <p className="detail-label">{productDetails ? productDetails.description : ""}</p>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="descriptionAddress">
                                {productDetails && productDetails.is_seller && <div className="seller-desc">
                                    <p className="mb-2">Seller</p>
                                    <h4 className="mb-2">{productDetails ? productDetails.sellerName : ""}</h4>
                                    {/* <div>
                                        <span>Joining Date: </span>
                                        <span>{moment(productDetails.sellerJoiningDate).format('MMMM Do YYYY')}</span>
                                    </div> */}
                                </div>}
                                <span className="descriptionLocation mb-1">
                                    <svg width="20" height="25" viewBox="0 0 20 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.65304 0.506052L9.65312 0.506049C15.0415 0.316238 19.4689 4.62286 19.4689 9.96538C19.4689 10.5789 19.4104 11.1775 19.2983 11.7615L19.2975 11.7659L19.2975 11.766L19.2975 11.7661L19.2975 11.7661L19.2975 11.7662L19.2975 11.7662L19.297 11.7688L19.2945 11.7816C19.2922 11.7935 19.2886 11.812 19.2835 11.8366C19.2734 11.886 19.2576 11.9601 19.2355 12.0557L19.2346 12.0597C19.0887 12.7159 18.8748 13.3421 18.598 13.9339L18.594 13.9424L18.5904 13.951C17.6161 16.2551 15.3515 20.1494 10.2247 24.4007C10.0848 24.5156 9.88719 24.5122 9.75664 24.4028L9.7549 24.4014C4.62735 20.1446 2.36267 16.25 1.39353 13.9562L1.39052 13.9491L1.38729 13.9421C1.11378 13.3468 0.894741 12.7141 0.74906 12.064L0.749209 12.064L0.746204 12.052C0.722708 11.9581 0.707931 11.8885 0.699325 11.8444C0.695021 11.8224 0.69226 11.8067 0.690722 11.7976L0.68936 11.7894L0.689293 11.7889L0.689282 11.7889L0.689192 11.7882L0.687837 11.7787L0.685695 11.7675C0.519648 10.8942 0.466311 9.98422 0.558753 9.04617L0.558852 9.04515C1.0116 4.35208 4.93362 0.671476 9.65304 0.506052ZM4.64321 10.0832C4.64321 13.034 7.03679 15.4244 9.98937 15.4244C12.942 15.4244 15.3355 13.034 15.3355 10.0832C15.3355 7.1324 12.9419 4.74201 9.98937 4.74201C7.03679 4.74201 4.64321 7.1324 4.64321 10.0832Z" fill="black" stroke="black" />
                                    </svg>

                                    {/* {productDetails ? productDetails.address : ""}, <br /> */}
                                    {productDetails ? productDetails.country : ""}, {productDetails ? productDetails.postalCode : ""}

                                </span>
                                <span>Member Since {moment(productDetails ? productDetails?.sellerJoiningDate : "").format('YYYY')}</span>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div className="mt-4 pt-2">
                        <h5 className="product-name mb-4 text-dark">Additional Information</h5>
                        {/* <div className="addtnlInfo d-flex justify-content-between"></div> */}
                        <div className="addtnlInfo d-flex justify-content-between">
                            <div className="row w-100">
                                <div className="col-lg-5">
                                    {/* <div className="row mb-3">
                                        <div className="col-lg-7 detail-label">Registration Number</div>
                                        <div className="col-lg-5"><p className="mb-0">{productDetails ? productDetails.regNumber : ""}</p>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-lg-7">Accreditations</div>
                                        <div className="col-lg-5"><p className="mb-0">{productDetails ? productDetails.accreditations : ""}</p></div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-lg-7">Teeth</div>
                                        <div className="col-lg-5"><p className="mb-0">{productDetails ? productDetails.teeth : ""}</p></div>
                                    </div> */}
                                    {/* <div className="row mb-3">
                                        <div className="col-lg-7">HGP treated</div>
                                        <div className="col-lg-5"><p className="mb-0">{productDetails ? productDetails.HGP_treated : ""}</p></div>
                                    </div> */}
                                    <div className="row mb-3">
                                        <div className="col-lg-7">Horns</div>
                                        <div className="col-lg-5"><p className="mb-0">{productDetails ? productDetails.horns : ""}</p>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-lg-7">Fertility</div>
                                        <div className="col-lg-5"><p className="mb-0">{productDetails ? productDetails.fertility : ""}</p></div>
                                    </div>
                                    {/* <div className="row mb-3">
                                        <div className="col-lg-7">Scrotal Circm</div>
                                        <div className="col-lg-5"><p className="mb-0">{productDetails ? productDetails.scrotalCirc : ""}</p></div>
                                    </div> */}
                                </div>
                                <div className="col-lg-2 col-lg-offset-2">

                                </div>
                                <div className="col-lg-5">
                                    <div className="row mb-3">
                                        <div className="col-lg-6">Pasture/Feed</div>
                                        <div className="col-lg-6"><p className="mb-0">{productDetails ? productDetails.feed : ""}</p>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-lg-6">Frame</div>
                                        <div className="col-lg-6"><p className="mb-0">{productDetails ? productDetails.frame : ""}</p>
                                        </div>
                                    </div>
                                    {/* <div className="row mb-3">
                                        <div className="col-lg-6">Condition</div>
                                        <div className="col-lg-6"><p className="mb-0">{"Missing Field"}</p>
                                        </div>
                                    </div> */}
                                    {/* <div className="row mb-3">
                                        <div className="col-lg-6">Vaccinations</div>
                                        <div className="col-lg-6"><p className="mb-0">{productDetails ? productDetails.vaccinations : ""}</p>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-lg-6">Scrotal Circm</div>
                                        <div className="col-lg-6"><p className="mb-0">{productDetails ? productDetails.scrotalCirc : ""}</p>
                                        </div>
                                    </div> */}

                                </div>
                            </div>

                        </div>
                    </div>
                    <hr />
                    <div className="mt-4 pt-2">
                        <h5 className="mainHeading mb-4 text-dark">Location</h5>
                        <div className="map mb-5">




                            {productDetails && productDetails.latlng && <iframe title="google map" src={`https://www.google.com/maps/embed/v1/place?q=${productDetails.latlng[1]},${productDetails.latlng[0]}&key=AIzaSyBApvvMp-DolYwwyo3C2jpq6lGDpZzLeiU`}
                                width="100%" height="450" frameborder="0" style={{ border: 0 }} allowfullscreen="" aria-hidden="false" tabindex="0">

                            </iframe>
                            }

                        </div>
                    </div>
                </div>
            </div>
            <Modal isOpen={openModal} toggle={toggle}>
                <ClaimListing verifytoggle={toggle} productId={productId} socket={props.socket} />
            </Modal>

            <Modal
                id="make-offer"
                isOpen={modal1}
                toggle={() => {
                    toggle1();
                }}
            >
                <ModalHeader
                    className="d-flex bg-white text-dark px-0"
                    toggle={() => {
                        toggle1();
                    }}
                >
                    <h5 className="modal-title mr-3 black-light">
                        Buy this Listing with
                        <span className="black-text ml-2">Secure payment</span>
                    </h5>
                </ModalHeader>
                <ModalBody className="modal-body  py-4">
                    <div className="row  ">
                        <div className="col-md-4 pl-md-0 min137 mb-3">
                            {productDetails && productDetails.images && productDetails.images.length != 0 && <img className="mb-4" width={200} height={200} src={`${process.env.REACT_APP_SERVER_URL}/images/${mainImage}`} alt="" />}
                            {productDetails && productDetails.images == 0 && <img className="border border-5 mb-4" width={200} height={200} src={`${process.env.REACT_APP_URL}/static/images/sample-img.jpg`} alt="" />}


                        </div>
                        <div className="col-md-8 d-flex flex-row flex-wrap">
                            <h3 className="black-text offer-name">
                                {productDetails ? productDetails.title : ""}
                            </h3>
                            <p className="offer-dis">
                                Secure payment allows buyers and sellers to negotiate safely
                                and securely online. we verify funds, monitor the exchange of
                                payment and ensure the entire transaction is completed
                                hassle-free.
                            </p>
                            <div className="align-self-end">
                                <button onClick={() => {
                                    if (Cookies.get('token') && loggedInUser) {
                                        if (productDetails.makeOfferPage) {
                                            setLoading(true);
                                            setdisable(true);
                                            setTimeout(() => {
                                                // window.location.href =productDetails.makeOfferPage;
                                                window.open(productDetails.makeOfferPage, "_blank")
                                                addbidusers({ productId: productDetails._id, userId: user._id })
                                                setLoading(false);
                                                setdisable(false);
                                            }, 500)
                                        }
                                        else {
                                            makeAnOffer();
                                        }
                                    }
                                    else {
                                        history.push('/login')
                                    }
                                }} className="sub-button px-5 m-width264 text-white" disabled={disable}  >
                                    {loading && <SyncLoader color={color} loading={loading} css={override} size={11} />}
                                    {!loading && <span> Make An Offer </span>}
                                </button>




                            </div>
                        </div>
                        <p className="text-center w-100 mt-5 black-light">
                            After Clicking Make an Offer you will be directed to Escrow.com
                        </p>
                        <p className="text-center w-100 black-light mb-0">
                            <span className="mr-2">Powered by</span>
                            <svg
                                width="22"
                                height="24"
                                viewBox="0 0 22 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M11.008 23.253H10.8129C10.7154 23.1555 -0.286879 20.2293 0.00573469 3.882V3.64791L1.50782 1.50208L1.80043 1.46307C1.9955 1.42405 11.008 0 11.008 0C11.008 0 20.0595 1.40454 20.2546 1.46307L20.4887 1.50208L21.9907 3.64791V3.882C22.1858 12.3483 19.2597 17.1666 16.7822 19.7026C14.0902 22.4727 11.2616 23.253 11.008 23.253ZM1.52732 4.17461C1.33225 18.103 9.66197 21.2632 11.0275 21.6924C12.432 21.2632 20.7032 18.0835 20.5277 4.11609L19.6108 2.80909C18.5964 2.575 14.5974 1.59962 11.047 1.50208C7.49663 1.59962 3.55611 2.575 2.48319 2.80909L1.52732 4.17461Z"
                                    fill="#01426A"
                                />
                                <path
                                    d="M15.4373 10.1635H7.26367V11.7631H15.4373V10.1635Z"
                                    fill="#01426A"
                                />
                                <path
                                    d="M15.4373 14.2015H7.26367V15.8011H15.4373V14.2015Z"
                                    fill="#01426A"
                                />
                                <path
                                    d="M15.4373 6.12537H7.26367V7.72499H15.4373V6.12537Z"
                                    fill="#01426A"
                                />
                                <path
                                    d="M7.22336 12.4068C6.44306 12.4068 5.7603 11.724 5.7603 10.9047C5.7603 10.1244 6.38454 9.40264 7.22336 9.40264H11.0664V8.29071H7.16484C5.70177 8.29071 4.58984 9.46116 4.58984 10.9242C4.58984 12.3873 5.7603 13.5577 7.16484 13.5577H11.0664V12.4068H7.22336Z"
                                    fill="#42C31D"
                                />
                            </svg>
                        </p>
                    </div>
                </ModalBody>
                <ModalFooter className="-flex justify-content-center w-100">
                    <a className="text-sky my-3" href="#">
                        Learn more about secure payment
                    </a>
                </ModalFooter>
            </Modal>
            {/* <Modal isOpen={openverifyModal} toggle={verifytoggle}> 
               <ClaimListingVerified     />
            </Modal> */}

        </>
    );
}

export default ProductDetails;